export default __webpack_public_path__ + "static/headstand-onelegup-header-8fa64e10eac796832d1c46bb57e98da0.png";